import React, { useCallback } from "react";
import { useLayout } from "../contexts/LayoutContext";
import SidebarAgentChat from "./SidebarAgentChat";

const AGENT_LABELS = {
  WIKI: "Wiki",
  GRAPH: "Graph",
  APTS: "Apts",
};

const FloatingChatButton = ({ agent = "WIKI" }) => {
  const { rightOpen, setIsRightOpen, setRightComponent } = useLayout();

  const handleClick = useCallback(() => {
    if (rightOpen) {
      setIsRightOpen(false);
      setRightComponent(null);
    } else {
      setRightComponent(<SidebarAgentChat agent={agent} />);
      setIsRightOpen(true);
    }
  }, [rightOpen, agent, setIsRightOpen, setRightComponent]);

  return (
    <button
      onClick={handleClick}
      className={`
        fixed right-0 top-1/2 -translate-y-1/2 z-20
        flex items-center gap-1.5
        pl-2.5 pr-2 py-3
        rounded-l-xl
        border border-r-0 border-mainBorder
        shadow-lg shadow-mainShadow
        transition-all duration-300 ease-in-out
        cursor-pointer
        ${
          rightOpen
            ? "bg-velBlue text-white"
            : "bg-mainBg text-secondaryText hover:text-velBlue hover:bg-mainBg/80"
        }
      `}
      title={`Chat with ${AGENT_LABELS[agent] || agent} Agent`}
    >
      {/* Chat icon */}
      <svg
        className="w-4 h-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
        />
      </svg>
    </button>
  );
};

export default FloatingChatButton;
